import { SvgFactory } from '../../Svg';

const PauseIcon = SvgFactory(
    <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='black'>
        <path d='M16 38C18.2 38 20 36.2 20 34V14C20 11.8 18.2 10 16 10C13.8 10 12 11.8 12 14V34C12 36.2 13.8 38 16 38ZM28 14V34C28 36.2 29.8 38 32 38C34.2 38 36 36.2 36 34V14C36 11.8 34.2 10 32 10C29.8 10 28 11.8 28 14Z' />
    </svg>,
);

export default PauseIcon;
